/* Diente — live search suggestions (Predictive Search API,
   rendered server-side through sections/predictive-search.liquid). */
(function () {
  'use strict';

  var MIN_CHARS = 2;
  var DEBOUNCE = 220;

  document.querySelectorAll('[data-predictive-search]').forEach(function (root) {
    if (root.hasAttribute('data-predictive-disabled')) return;

    var input = root.querySelector('[data-predictive-input]');
    var results = root.querySelector('[data-predictive-results]');
    if (!input || !results) return;

    var timer = null;
    var controller = null;

    function hide() {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    }

    function show(html) {
      results.innerHTML = html;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function search(term) {
      if (controller) controller.abort();
      controller = new AbortController();

      var url =
        window.theme.routes.predictiveSearch +
        '?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6' +
        '&section_id=predictive-search';

      fetch(url, { signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (text) {
          var parsed = new DOMParser().parseFromString(text, 'text/html');
          var inner = parsed.querySelector('[data-predictive-inner]');
          if (inner) {
            show(inner.innerHTML);
            window.Diente.announce(inner.getAttribute('data-predictive-status'));
          } else {
            hide();
          }
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') {
            hide();
            window.Diente.announce(window.theme.strings.predictiveSearchError);
          }
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);

      if (term.length < MIN_CHARS) {
        hide();
        return;
      }
      timer = setTimeout(function () {
        search(term);
      }, DEBOUNCE);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS && results.innerHTML) {
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    // Arrow-key navigation through the suggestion list.
    root.addEventListener('keydown', function (event) {
      if (results.hidden) {
        if (event.key === 'Escape') input.blur();
        return;
      }

      var items = Array.prototype.slice.call(results.querySelectorAll('a'));
      if (!items.length) return;

      var index = items.indexOf(document.activeElement);

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        items[Math.min(index + 1, items.length - 1)].focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (index <= 0) input.focus();
        else items[index - 1].focus();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        hide();
        input.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) hide();
    });
  });
})();
